import React, { Component, createElement } from 'react';
import { Tabs as OriginalTabs, ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import enUS from 'antd/es/locale/en_US';
import 'antd/dist/antd.variable.min.css';
import '../../variables.scss';
import { warning } from '../../utils/warning';
class Tabs extends Component {
    state = {
        activeKey: this.props.activeKey ?? this.props.defaultActiveKey,
    };
    _handleChange = (key) => {
        this.setActiveKey(key);
    };
    // 编辑器里可以通过 this.$(refId).setActiveKey(key) 调用
    setActiveKey = (key) => {
        const { onChange = () => { } } = this.props;
        this.setState({ activeKey: key });
        onChange(key);
    };
    // 编辑器里可以通过 this.$(refId).getActiveKey() 调用
    getActiveKey = () => {
        return this.state.activeKey;
    };
    render() {
        ConfigProvider.config({
            theme: {
                primaryColor: '#f16622',
            },
        });
        const { props } = this;
        const { activeKey } = this.state;
        const { children } = props;
        let items = props.items;
        // props.items 存在，只认 props.items
        // 兼容代码：props.childrens 反推 props.items
        if (!props.items && Array.isArray(children) && children.length > 0) {
            warning('Tabs.TabPane is deprecated. Please use `items` directly.');
            items = children
                .map((node) => {
                if (React.isValidElement(node)) {
                    const { key, props } = node;
                    const { tab, ...restProps } = props || {};
                    const item = {
                        key: String(key),
                        ...restProps,
                        label: tab,
                    };
                    return item;
                }
                return null;
            })
                .filter(Boolean);
        }
        return (createElement(ConfigProvider, { locale: localStorage.getItem('umi_locale') !== 'en-US' ? zhCN : enUS },
            createElement(OriginalTabs, { ...props, items: items, activeKey: activeKey, onChange: this._handleChange })));
    }
}
Tabs.TabPane = OriginalTabs.TabPane;
export default Tabs;
